export default "__VITE_ASSET__BdBCVo6c__"